import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../features/apiServices/apiClient";
import { clearSubscriptionStatus } from "../features/subscription/subscriptionState";
import "./css/LoginPage.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/auth/login", { email, password });

      // NOVO - agora recebemos accessToken e refreshToken
      const {
        accessToken,
        refreshToken,
        tenant,
        user,
        restaurants
      } = response.data;

      // NOVO – salvar corretamente no localStorage
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      // compatibilidade com partes antigas do código
      //localStorage.setItem("token", accessToken);

      localStorage.setItem("tenant", JSON.stringify(tenant));
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("restaurants", JSON.stringify(restaurants));

      // Drop the gate decision cached for the previous session.
      clearSubscriptionStatus();

      navigate("/home");

    } catch (err) {
      setError("Usuário ou senha inválidos.");
    }
  };

  return (
    <div className="login-container">
      {/* COLUNA ESQUERDA */}
      <div className="left-section">
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick Logo"
          className="left-logo"
          onClick={() => navigate("/")}
        />

        <h1 className="left-title">Gerencie seu restaurante com facilidade</h1>
        <p className="left-subtitle">
          Agilidade, controle e eficiência para sua operação.
        </p>
      </div>

      {/* COLUNA DIREITA */}
      <div className="right-section">
        <div className="login-card">
          <h2>Entrar</h2>

          <form onSubmit={handleLogin}>
            <label>E-mail</label>
            <input
              type="email"
              placeholder="usuario@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Senha</label>
            <input
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="login-btn">Entrar</button>

            <p className="forgot"
              onClick={() => navigate("/forgot-password")}
            >
              Esqueci minha senha
            </p>

            <p className="signup-text">
              Ainda não tem conta?
              <span onClick={() => navigate("/signup")}> Criar conta</span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
